import type { ReactNode } from 'react';

export function ChatPageLayout({ children }: { children: ReactNode }) {
  return (
    <main aria-labelledby="chat-page-heading" className="flex h-full flex-col">
      <header className="border-b border-border px-4 py-2">
        <h1 id="chat-page-heading" className="text-lg font-semibold">
          Chat
        </h1>
      </header>
      {children}
    </main>
  );
}
